@if (lawSection === '26') {
  <ng-container
    *ngTemplateOutlet="
      certificateStatusTemplate;
      context: { $implicit: certStatusSec26, lawSection: '26' }
    "
  >
  </ng-container>
}
@if (lawSection === '28') {
  <ng-container
    *ngTemplateOutlet="
      certificateStatusTemplate;
      context: { $implicit: certStatusSec28 }
    "
  >
  </ng-container>
}

<ng-template
  #certificateStatusTemplate
  let-certStatus
  let-lawSection="lawSection"
>
  <div class="validity-status align-items-baseline">
    @switch (certStatus) {
      @case ('valid') {
        <ng-container
          [ngTemplateOutlet]="statusBadge"
          [ngTemplateOutletContext]="{
            icon: 'assets/images/icons/marks/circle-check.svg#circle-check',
            text: 'CERTIFICATE.VALID' | translate,
            color: '#258D3F',
            bgColor: '#EBF9EE',
          }"
        ></ng-container>
      }

      @case ('expired') {
        <ng-container
          [ngTemplateOutlet]="statusBadge"
          [ngTemplateOutletContext]="{
            icon: 'assets/images/icons/marks/circle-xmark.svg#circle-xmark',
            text:
              (lawSection === '26'
                ? 'CERTIFICATE.Expired system will automatically create a new one when user approve the document'
                : 'CERTIFICATE.EXPIRED'
              ) | translate,
            color: '#E8362C',
            bgColor: '#FEEBEB',
          }"
        ></ng-container>
      }

      @case ('revoked') {
        <ng-container
          [ngTemplateOutlet]="statusBadge"
          [ngTemplateOutletContext]="{
            icon: 'assets/images/icons/marks/circle-xmark.svg#circle-xmark',
            text: 'CERTIFICATE.REVOKED' | translate,
            color: '#E8362C',
            bgColor: '#FEEBEB',
          }"
        ></ng-container>
      }

      @case ('not_created') {
        @if (lawSection === '26') {
          <ng-container
            [ngTemplateOutlet]="statusBadge"
            [ngTemplateOutletContext]="{
              icon: 'assets/images/icons/marks/warning-circle.svg#warning-circle',
              text:
                'CERTIFICATE.USER-NO-CERT-SYSTEM-CREATE' | translate,
              color: '#FF9500',
              bgColor: '#FFF4E6',
            }"
          ></ng-container>
        } @else {
          <ng-container
            [ngTemplateOutlet]="statusBadge"
            [ngTemplateOutletContext]="{
              icon: 'assets/images/icons/marks/circle-xmark.svg#circle-xmark',
              text: 'CERTIFICATE.NOT-CREATED' | translate,
              color: '#E8362C',
              bgColor: '#FEEBEB',
            }"
          ></ng-container>
        }
      }
    }
  </div>
</ng-template>

<ng-template
  #statusBadge
  let-icon="icon"
  let-text="text"
  let-color="color"
  let-bgColor="bgColor"
>
  <div class="law-section-badge" [style.--bgColor]="bgColor">
    <svg
      class="icon-prepend flex-shrink-0"
      [attr.stroke]="color"
      stroke-width="1.5"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <use [attr.href]="icon" height="20" width="20"></use>
    </svg>
    <span>{{ text }}</span>
  </div>
</ng-template>
